import React from 'react';
import dayjs from 'dayjs';
import { dateFormat } from 'core/constants';
import { TRow } from 'shared/Table/Table.models';
import { MRT_ColumnDef as ColumnDef } from 'material-react-table';
import convertDataFromFormToTable from 'core/utilities/convertDataFromFormToTable';
// eslint-disable-next-line no-unused-vars
import { ITableCellContract } from 'pages/ContractManagment/ContractManagement.models';
import { RequestTypeLabels, RequestTypeOptions } from 'pages/ContractManagment/constants';

export const columns = [
  {
    header: 'Request type',
    accessorKey: 'requestType',
    Cell: ({ row }: ITableCellContract) => (
      <span>{RequestTypeLabels[row.original.requestType]}</span>
    ),
    filterVariant: 'select',
    filterFn: 'equals',
    filterSelectOptions: convertDataFromFormToTable(RequestTypeOptions),
    muiTableHeadCellFilterTextFieldProps: { placeholder: 'Select status' },
  },
  {
    header: 'Customer name',
    accessorKey: 'customerName',
    minWidth: '100px',
    muiTableHeadCellFilterTextFieldProps: { placeholder: 'Enter Customer Name' },
    sortDescFirst: false,
  },
  {
    header: 'Seller',
    accessorKey: 'sellerFullname',
    minWidth: '100px',
    muiTableHeadCellFilterTextFieldProps: { placeholder: 'Enter Seller' },
    sortDescFirst: false,
  },
  {
    header: 'Request created date',
    accessorKey: 'createdAt',
    minSize: 100,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) => renderedCellValue && (
      dayjs(renderedCellValue as string).format(dateFormat)
    ),
  },
  {
    header: 'Request accepted date',
    accessorKey: 'acceptedAt',
    minSize: 100,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) => renderedCellValue && (
      dayjs(renderedCellValue as string).format(dateFormat)
    ),
  },
  {
    header: 'Contract Specialist',
    accessorKey: 'contractSpecialistFullname',
    minWidth: '100px',
    muiTableHeadCellFilterTextFieldProps: { placeholder: 'Enter Contract Specialist' },
    sortDescFirst: false,
  },
  {
    header: 'Canceled/ Declined Date',
    accessorKey: 'canceledAt',
    minSize: 100,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) => renderedCellValue && (
      dayjs(renderedCellValue as string).format(dateFormat)
    ),
  },
  {
    header: 'Completed date',
    accessorKey: 'completedAt',
    minSize: 100,
    enableColumnFilter: false,
    Cell: ({ renderedCellValue }) => renderedCellValue && (
      dayjs(renderedCellValue as string).format(dateFormat)
    ),
  },
] as ColumnDef<TRow>[];
